// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1P-Kj","selects":"Documents_selects__1y0D6"};